import { getUserInfo } from './authorization';
import { info, warn } from '../notify';
import { fetchAvailableRoles, goToMinSide } from '../user';

export const activationKey = 'email';
export const nibioToken = {};
const ws = '/klimagasskalkulator_ws';

const extractToken = (jwt) => {
  const parsed = parseJwt(jwt);
  // console.log('User from parsed token:', parsed.user);
  nibioToken.expiration = parsed.exp * 1000;
  // if (parsed.user) setUserName(parsed.user.name);
  nibioToken.user = parsed.user;
};

const getCleanUrl = () => {
  const path = window.location.pathname.replace(/index\.html.*/, '');
  return window.location.origin + path;
};

const forgetToken = () => {
  sessionStorage.removeItem('nibioToken');
  delete nibioToken.token;
  delete nibioToken.expiration;
  delete nibioToken.user;
};

const resetAuthentication = () => {
  // Remove query parameters from URL without refreshing the page
  // window.location.search = ''; // not desirable, it also refreshes
  window.history.replaceState({}, document.title, '.');
  sessionStorage.removeItem('codeVerifier');
  forgetToken();
  wizard.classList.remove('logged-in');
};

const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(
    c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
  ).join(''));
  return JSON.parse(jsonPayload);
};

const existingLocalToken = () => {
  nibioToken.token = nibioToken.hasOwnProperty('token') ?
    nibioToken.token : sessionStorage.getItem('nibioToken');
  return nibioToken.token;
};

const validLocalToken = () => {
  // Check expiration locally before asking back-end, unless we do not have it
  const expiration = nibioToken.expiration;
  const remaining = expiration ? expiration - new Date() : 1;
  // console.log('expired', remaining <= 0);
  return existingLocalToken() && (remaining > 0);
};

// ID Porten
export const idPorten = (request, onSuccess, onError, onComplete) => {
  let ok;
  fetch(request).then(r => {
    ok = r.ok;
    const j = r.headers.get('content-type')?.indexOf('application/json') > -1;
    // if (r.ok && json) return r.json(); else return r.text();
    // not all APIes have correct content-type
    return r.text();
  }).then(text => {
    let response = text;
    let json = false;
    try {
      response = JSON.parse(text); // Try to parse the response as JSON
      // The response was a JSON object
      json = true;
    } catch(e) {} // The response wasn't a JSON object
    // console.log(`${request.url.split('?')[0].split('/').at(-1)}:`, response);
    if (
      (json && !(response.isSuccess === false)) || (!json && ok)
    ) onSuccess(response);
    else {
      const msg = response.errorMessage ?? response;
      console.log(`Feil: ${msg}`);
      if (onError) onError(response);
    }
  }).catch(err => { // code to handle request errors
    console.log('Back-end ikke klar!', err);
  }).then(onComplete);
};

export const login = (e) => {
  // console.log('Start log-in process');
  const btn = e.target;
  btn.classList.add('loading');
  const routing = 'clientCallbackRoutingUrl=';
  const request = new Request(`${ws}/signIn?${routing}`, {
    method: 'GET',
    headers: new Headers({ clienturl: getCleanUrl() })
  });
  idPorten(
    request,
    response => {
      // Store codeVerifier, needed in getToken request later
      sessionStorage.setItem('codeVerifier', response.codeVerifier);
      window.location = response.authorizationRequestUri;
    },
    undefined,
    () => btn.classList.remove('loading')
  );
};

const logoutCompletely = (token) => { // not just on our server, on IDPorten too
  console.log('log-out completely');
  const routing = 'clientCallbackRoutingUrl=';
  const request = new Request(`${ws}/signouturl?${routing}`, {
    method: 'GET',
    headers: new Headers({
      clienturl: getCleanUrl(),
      nibiotoken: token,
      state: ''
    })
  });
  idPorten(request, response => window.location = response.url);
};

export const logout = (completely) => {
  // console.log('Start log-out process');
  sessionStorage.removeItem(activationKey);
  const btn = document.getElementById('logoutBtn');
  btn.classList.add('loading');
  getIdPortenToken().then(token => {
    if (completely) logoutCompletely(token);
    const request = new Request(`${ws}/signout`, {
      method: 'GET',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(
      request,
      () => console.log('Internal server log out'),
      undefined,
      () => {
        resetAuthentication();
        btn.classList.remove('loading');
      }
    );
  });
};

export const getIdPortenToken = () => new Promise((resolve, reject) => {
  const api = `${ws}/getToken`;
  const routing = 'clientCallbackRoutingUrl=';
  const urlParameters = new URLSearchParams(window.location.search);
  const c = urlParameters.get('code');
  const cv = sessionStorage.getItem('codeVerifier');
  if (!c || !cv) return reject('Mangler verifiseringskoder');
  const code = `code=${c}`;
  const codeVerifier = `codeVerifier=${cv}`;
  const request = new Request(`${api}?${routing}&${code}&${codeVerifier}`, {
    method: 'GET',
    headers: new Headers({ clienturl: getCleanUrl() })
  });
  if (existingLocalToken()) {
    extractToken(nibioToken.token);
    resolve(nibioToken.token);
  } else {
    console.log('Request nibioToken from ID Porten only once');
    idPorten(request, response => {
      const t = JSON.parse(response.nibioToken);
      nibioToken.token = t.nibioToken;
      extractToken(t.nibioToken);
      sessionStorage.setItem('nibioToken', t.nibioToken);
      resolve(nibioToken.token);
    }, response => reject(response.errorMessage));
  }
});

const updateToken = (msg) => {
  console.log('updateToken');
  info(`${msg}!`);
  getIdPortenToken().then(token => {
    const request = new Request(`${ws}/renewToken`, {
      method: 'GET',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(request, response => console.log('Updated token'));
  });
};

const otpCheck = (autoLogInFirst) => new Promise((resolve, reject) => {
  const urlParameters = new URLSearchParams(window.location.search);
  const urlValue = urlParameters.get(activationKey);
  if (urlValue) sessionStorage.setItem(activationKey, urlValue);
  const activationValue = urlValue ?? sessionStorage.getItem(activationKey);
  if (activationValue) {
    if (autoLogInFirst) login({ target: document.getElementById('loginBtn') });
  } else reject('No activation, activation key not present as url parameter');
});

export const authenticationCheck = (complete) => {
  // console.log('Authentication check');
  getIdPortenToken().then(token => {
    // console.log(token);
    const request = new Request(`${ws}/isUserAuthenticated`, {
      method: 'GET',
      headers: new Headers({ nibiotoken: token })
    });
    idPorten(request, response => {
      if (response.isValidUserToken) {
        // Ping internal server to reset/prolongue expiration by other 10 minutes
        setTimeout(authenticationCheck, 1000 * 60 * 1);
        if (!complete) return;
        wizard.classList.add('logged-in');
        // nibioToken.expiration = response.expirationTime;
        const time = new Date(response.expirationTime).toLocaleString('nb-NO');
        console.log('Brukeren er logget inn til', time);
        getUserInfo().then(info => {
          user.classList.add('registered');
          wizard.classList.add('registered');
          if (!info.verifiedEmail) goToMinSide('verified');
        }).catch(() => {
          warn('Brukeren er ikke registrert ennå');
          goToMinSide('verified');
        });
      } else {
        console.log('Ugyldig eller utløpt token:', response.errorMessage);
        resetAuthentication();
        otpCheck(true).then(m => updateToken(m)).catch(m => console.log(m));
      }
    }, () => {
      console.log('Ugyldig eller utløpt token');
      resetAuthentication();
      otpCheck(true).then(m => updateToken(m)).catch(m => console.log(m));
    });
  }).catch(msg => {
    warn('Brukeren har ikke logget seg inn ennå');
    otpCheck(true).then(msg => updateToken(msg)).catch(msg => null);
  });
};
